/* Zweit-Domain minibio.info: neutrale Adresse für Mini-Websites (global, nur Mini-Websites).
   dimedial.studio/@handle bleibt gültig. Host-Erkennung + Adress-Helfer. */

export const MINIBIO_HOST = "minibio.info";

/* Dev-/Vorschau-Override: ?mb=1 schaltet den minibio-Modus ein, ?mb=0 wieder aus (in localStorage gemerkt). */
function override() {
  try {
    const u = new URL(window.location.href);
    const v = u.searchParams.get("mb");
    if (v === "1") window.localStorage.setItem("mb-host", "1");
    if (v === "0") window.localStorage.removeItem("mb-host");
    return window.localStorage.getItem("mb-host") === "1";
  } catch { return false; }
}

export function isMinibioHost() {
  if (typeof window === "undefined") return false;
  const h = (window.location.hostname || "").toLowerCase();
  if (h === MINIBIO_HOST || h.endsWith("." + MINIBIO_HOST)) return true;
  return override();
}

/* Vollständige, öffentliche Adresse einer Mini-Website je gewählter Hauptadresse. */
export function primaryUrl(handle, mode) {
  const h = (handle || "").replace(/^@/, "");
  if (!h) return "";
  return mode === "dimedial" ? `https://dimedial.studio/@${h}` : `https://${MINIBIO_HOST}/${h}`;
}

/* Anzeige ohne Protokoll. */
export function primaryLabel(handle, mode) {
  const h = (handle || "").replace(/^@/, "");
  return mode === "dimedial" ? `dimedial.studio/@${h}` : `${MINIBIO_HOST}/${h}`;
}
